define('data-transformers/xml-to-json',['require','exports','module','xml-to-json/xml-to-json'],function(require,exports,module) {
	var xmlToJson=require('xml-to-json/xml-to-json');

	return function(data, datasource, params){
	 	return data && xmlToJson(data.xml||data.responseXML||data.text) || null;
	};
});
